// Pages légales : /legal/mentions, /legal/confidentialite, /legal/cgv, /legal/dpa
// ⚠️ Les champs ÉDITEUR sont à compléter dès l'immatriculation de la micro-entreprise.
import { useParams } from 'react-router-dom'
import { CHARBON, SABLE, Logo, LiensLegaux } from './actions'

const EDITEUR = {
  nom: '[À COMPLÉTER : Prénom NOM]',
  statut: 'Entrepreneur individuel (micro-entreprise)',
  siret: '[À COMPLÉTER : SIRET]',
  adresse: '[À COMPLÉTER : adresse postale]',
  email: 'contact.jeebi@gmail.com',
  tva: 'TVA non applicable, art. 293 B du CGI',
  majLe: '16 octobre 2026',
}

const H = ({ children }) => <h2 style={{ fontSize: 18, color: CHARBON, margin: '1.75rem 0 0.5rem' }}>{children}</h2>
const P = ({ children }) => <p style={{ margin: '0.5rem 0', lineHeight: 1.6 }}>{children}</p>
const L = ({ items }) => <ul style={{ paddingLeft: '1.25rem', lineHeight: 1.6 }}>{items.map((t, i) => <li key={i}>{t}</li>)}</ul>

const PAGES = {
  mentions: {
    titre: 'Mentions légales',
    contenu: (
      <>
        <H>Éditeur du service</H>
        <P>Jeebi est édité par {EDITEUR.nom}, {EDITEUR.statut}.<br />
          SIRET : {EDITEUR.siret}<br />
          Adresse : {EDITEUR.adresse}<br />
          Contact : {EDITEUR.email}<br />
          {EDITEUR.tva}</P>
        <P>Directeur de la publication : {EDITEUR.nom}.</P>
        <H>Hébergement</H>
        <P>Interface web : Vercel Inc., 440 N Barranca Ave #4133, Covina, CA 91723, États-Unis — vercel.com.</P>
        <P>Base de données et serveurs applicatifs : Supabase Inc., région Union européenne (Paris, France) — supabase.com.</P>
        <H>Propriété intellectuelle</H>
        <P>Le nom Jeebi, son logo et l'ensemble des contenus du site sont la propriété de l'éditeur. Toute reproduction sans autorisation est interdite.</P>
      </>
    ),
  },

  confidentialite: {
    titre: 'Politique de confidentialité',
    contenu: (
      <>
        <P>Jeebi est un service de cartes de fidélité digitales utilisé par des commerces de proximité. Cette page explique quelles données sont traitées, pourquoi, et quels sont vos droits.</P>

        <H>1. Qui est responsable de vos données ?</H>
        <P><b>Vous êtes client d'un commerce</b> (vous avez scanné un QR code au comptoir) : le <b>commerce</b> chez qui vous avez créé votre carte est responsable du traitement. Jeebi agit pour son compte, en tant que <b>sous-traitant</b> (article 28 du RGPD).</P>
        <P><b>Vous êtes commerçant</b> et utilisez Jeebi : l'éditeur de Jeebi ({EDITEUR.nom}, {EDITEUR.email}) est responsable du traitement de vos données de compte.</P>

        <H>2. Données collectées</H>
        <P><b>Clients des commerces :</b></P>
        <L items={[
          'Prénom (obligatoire) et numéro de téléphone (facultatif)',
          'Nombre de tampons et date de chaque passage',
          'Votre choix concernant les offres du commerce, et la date de ce choix',
        ]} />
        <P><b>Commerçants :</b> nom du commerce, type d'activité, email, téléphone, mot de passe (chiffré, jamais lisible).</P>

        <H>3. Pourquoi ?</H>
        <L items={[
          'Gérer votre carte de fidélité et vos récompenses (exécution du service demandé)',
          "Vous envoyer les offres du commerce, uniquement si vous avez coché la case prévue (consentement)",
          'Permettre au commerçant de voir la fréquentation de son commerce (intérêt légitime)',
        ]} />
        <P>Aucune donnée n'est vendue, ni utilisée pour de la publicité ciblée.</P>

        <H>4. Destinataires et sous-traitants</H>
        <L items={[
          'Le commerce chez qui vous avez votre carte',
          "Supabase (hébergement des données, serveurs dans l'Union européenne)",
          'Vercel (affichage du site)',
          "Google (si vous ajoutez votre carte à Google Wallet : votre prénom et vos tampons sont transmis à Google pour afficher la carte, selon les règles de confidentialité de Google)",
        ]} />
        <P>Certains de ces prestataires sont des sociétés américaines. Les transferts sont encadrés par le cadre de protection des données UE–États-Unis (Data Privacy Framework) ou par les clauses contractuelles types de la Commission européenne.</P>

        <H>5. Durée de conservation</H>
        <L items={[
          'Carte de fidélité : tant que la carte est utilisée, puis suppression 3 ans après votre dernier passage',
          "Consentement aux offres : jusqu'à votre désinscription",
          'Compte commerçant : pendant la durée de l\'abonnement, puis 3 ans maximum',
        ]} />

        <H>6. Vos droits</H>
        <P>Vous pouvez à tout moment accéder à vos données, les rectifier, les supprimer, vous opposer à leur utilisation, demander leur portabilité ou retirer votre consentement aux offres. Écrivez au commerce concerné ou à {EDITEUR.email} : nous transmettons et traitons la demande sous un mois.</P>
        <P>Clients des commerces : le lien « Mes préférences et mes données », au dos de votre carte dans votre Wallet, vous permet à tout moment de refuser les offres ou de supprimer immédiatement votre carte et vos données.</P>
        <P>Si vous estimez que vos droits ne sont pas respectés, vous pouvez saisir la CNIL (cnil.fr).</P>

        <H>7. Cookies</H>
        <P>Jeebi n'utilise ni cookie publicitaire ni outil de mesure d'audience. Seuls des éléments techniques indispensables sont stockés dans votre navigateur (session de connexion du commerçant, mémorisation de votre carte sur la page d'inscription).</P>
      </>
    ),
  },

  cgv: {
    titre: 'Conditions générales de vente et d\'utilisation',
    contenu: (
      <>
        <P>Les présentes conditions s'appliquent entre {EDITEUR.nom} ({EDITEUR.statut}, SIRET {EDITEUR.siret}), ci-après « Jeebi », et tout professionnel qui souscrit au service, ci-après « le Commerçant ».</P>

        <H>1. Service</H>
        <P>Jeebi fournit un logiciel en ligne permettant au Commerçant de proposer à ses clients une carte de fidélité à tampons, ajoutable à Google Wallet (et Apple Wallet lorsque disponible), ainsi qu'un tableau de bord de suivi. Une prestation d'installation peut être proposée (configuration, affiche QR, prise en main).</P>

        <H>2. Prix et paiement</H>
        <P>Les prix sont ceux indiqués sur le devis ou la page tarifs au jour de la souscription, en euros. {EDITEUR.tva}. L'abonnement est payable d'avance, mensuellement ou annuellement. Les frais d'installation sont payables à la commande.</P>
        <P>En cas de retard de paiement, des pénalités au taux de 3 fois le taux d'intérêt légal sont exigibles, ainsi qu'une indemnité forfaitaire de 40 € pour frais de recouvrement (articles L441-10 et D441-5 du Code de commerce).</P>

        <H>3. Durée et résiliation</H>
        <P>L'abonnement mensuel est sans engagement et résiliable à tout moment par email, avec effet à la fin de la période payée. L'abonnement annuel est dû pour l'année entamée. À la résiliation, le Commerçant peut récupérer l'export de ses données clients pendant 30 jours, après quoi elles sont supprimées.</P>

        <H>4. Obligations du Commerçant</H>
        <L items={[
          "Utiliser le service conformément à la loi, notamment au RGPD et aux règles de prospection commerciale (article L34-5 du Code des postes et communications électroniques)",
          "N'envoyer des offres qu'aux clients ayant donné leur consentement",
          "Informer ses clients de l'existence de la carte et de leurs droits (l'affiche fournie et la page d'inscription y contribuent)",
          'Garder ses identifiants confidentiels',
          "Ne pas conditionner l'octroi de tampons ou de récompenses au dépôt d'un avis en ligne",
        ]} />

        <H>5. Disponibilité et responsabilité</H>
        <P>Jeebi met en œuvre les moyens raisonnables pour assurer la disponibilité du service, sans garantie d'absence d'interruption. Jeebi dépend de services tiers (Google Wallet, Apple Wallet, hébergeurs) dont il ne maîtrise pas le fonctionnement. La responsabilité de Jeebi est limitée au montant payé par le Commerçant sur les 12 derniers mois.</P>

        <H>6. Données personnelles</H>
        <P>Pour les données des clients finaux, le Commerçant est responsable de traitement et Jeebi est sous-traitant. Les engagements de Jeebi sont détaillés dans l'<a href="/legal/dpa">accord de traitement des données</a>, qui fait partie intégrante des présentes conditions.</P>

        <H>7. Droit applicable</H>
        <P>Les présentes conditions sont soumises au droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux compétents sont ceux du ressort du siège de Jeebi.</P>
      </>
    ),
  },

  dpa: {
    titre: 'Accord de traitement des données (article 28 RGPD)',
    contenu: (
      <>
        <P>Cet accord complète les conditions générales. Il s'applique aux données des clients finaux que Jeebi traite pour le compte du Commerçant.</P>
        <H>1. Objet du traitement</H>
        <P>Gestion de cartes de fidélité : création des cartes, enregistrement des passages, affichage dans les portefeuilles mobiles, statistiques de fréquentation et, si le client y a consenti, envoi d'offres du Commerçant.</P>
        <H>2. Données et personnes concernées</H>
        <P>Clients du Commerçant : prénom, téléphone facultatif, historique des passages, choix relatif aux offres.</P>
        <H>3. Engagements de Jeebi</H>
        <L items={[
          'Ne traiter les données que sur instruction documentée du Commerçant et pour la seule finalité ci-dessus',
          'Garantir la confidentialité des données, y compris par les personnes autorisées à y accéder',
          "Mettre en œuvre des mesures de sécurité adaptées : chiffrement des échanges (HTTPS), cloisonnement des données par commerce, accès restreint, mots de passe chiffrés, hébergement des données dans l'Union européenne",
          'Ne recourir qu\'aux sous-traitants listés dans la politique de confidentialité, et informer le Commerçant de tout changement',
          "Aider le Commerçant à répondre aux demandes d'exercice des droits des personnes",
          'Notifier au Commerçant toute violation de données dans les meilleurs délais, et au plus tard 48 heures après en avoir pris connaissance',
          'Supprimer ou restituer les données à la fin du contrat, au choix du Commerçant',
          'Mettre à disposition les informations nécessaires pour démontrer le respect de ces obligations',
        ]} />
        <H>4. Engagements du Commerçant</H>
        <P>Fournir à Jeebi des instructions conformes au RGPD, informer ses clients, recueillir leur consentement lorsqu'il est requis et tenir son registre des traitements.</P>
      </>
    ),
  },
}

export default function Legal() {
  const { page } = useParams()
  const doc = PAGES[page] || PAGES.mentions
  return (
    <div style={{ minHeight: '100vh', background: SABLE, fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif', padding: '2rem 1rem' }}>
      <div style={{ maxWidth: 720, margin: '0 auto', background: '#fff', borderRadius: 16, padding: 'clamp(1.25rem, 4vw, 2.5rem)', border: '1px solid #e8e0d8', color: '#444', fontSize: 15 }}>
        <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', color: CHARBON, fontWeight: 800, marginBottom: '1.5rem' }}>
          <Logo size={28} /> jeebi
        </a>
        <h1 style={{ fontSize: 26, color: CHARBON, margin: 0 }}>{doc.titre}</h1>
        <div style={{ fontSize: 12, color: '#aaa', marginTop: 4 }}>Dernière mise à jour : {EDITEUR.majLe}</div>
        {doc.contenu}
      </div>
      <LiensLegaux style={{ marginTop: '1.5rem' }} />
    </div>
  )
}
